/**
 * Convert time to proper MM:SS format:
 *  12 -> '00:12'
 *  74 -> '1:14'
 *  ':12' -> '0:12'
 *  '1:12' -> '1:12'
 *  '1:74' -> '2:14'
 *  'ab:' -> ''
 * @param {Number|String} input
 * @returns {*}
 */
export const getMinutesSecondsTime = (input: string | number) => {
  let matchedSeconds
  let matchedMinutes

  if (Number(input)) {
    matchedMinutes = 0
    matchedSeconds = Number(input)
  } else {
    const inputString = String(input)
    const format = /^(\d*):?(\d+)$/
    const match = inputString.match(format)

    if (!match) {
      return ''
    }

    matchedMinutes = match[1] ? Number(match[1]) : 0
    matchedSeconds = match[2] ? Number(match[2]) : 0
  }

  const additionalMinutes = Math.floor(matchedSeconds / 60)
  const seconds = matchedSeconds - additionalMinutes * 60
  const minutes = matchedMinutes + additionalMinutes
  const secondsFormatted =
    seconds < 9.5 ? '0' + seconds.toFixed(0) : String(seconds.toFixed(0))
  const minutesFormatted = String(minutes)
  return `${minutesFormatted}:${secondsFormatted}`
}
